/**
 * asArray — normalize an API list response into a real array.
 *
 * List endpoints are expected to return a bare JSON array, but a backend change,
 * a paginated wrapper, an error envelope or a proxy page can hand the frontend
 * an object, `null` or a string instead. A guard like `data || []` lets any
 * truthy non-array through, and the first `.filter()` / `.map()` in render then
 * throws and unmounts the tree. Call this at the data boundary (the agent/hook
 * that receives the response) so state is always an array.
 *
 * @param {*} value - Raw response body.
 * @returns {Array} `value` if it is an array; otherwise the first array found
 *   on `value.items`, `value.results` or `value.data`; otherwise `[]`.
 */
const WRAPPER_KEYS = ['items', 'results', 'data'];

export default function asArray(value) {
  if (Array.isArray(value)) return value;
  if (value && typeof value === 'object') {
    for (const key of WRAPPER_KEYS) {
      if (Array.isArray(value[key])) return value[key];
    }
  }
  return [];
}

export { asArray };
